export const user_stores = {
    api: {
        menu:                                   '/menu/{lang}/',
        menu_list:                              '/menu/{lang}/list',
        menu_update:                            '/menu/{lang}/{menu_id}',
        menu_activate:                          '/menu/{lang}/activate/{menu_id}/{isactive}',

        category:                               '/category/{lang}/',
        category_list:                          '/category/{lang}/list',
        category_update:                        '/category/{lang}/{category_id}',
        category_activate:                      '/category/{lang}/activate/{category_id}/{isactive}',

        manufacturer:                           '/manufacturer/{lang}/',
        manufacturer_list:                      '/manufacturer/{lang}/list',
        manufacturer_update:                    '/manufacturer/{lang}/{manufacturer_id}',
        manufacturer_activate:                  '/manufacturer/{lang}/activate/{manufacturer_id}/{isactive}',

        products:                               '/products/{lang}/',
        products_lazy:                          '/products/{lang}/lazy',
        products_update:                        '/products/{lang}/{product_id}',
        products_image_remove:                  '/products/{lang}/{product_id}/images',
        products_activate:                      '/products/{lang}/activate/{product_id}/{isactive}',
        products_web_activate:                  '/products/{lang}/web_activate/{product_id}/{isactive}',

        // products_category:                      '/product_category/{lang}/',
        // products_category_update:               '/product_category/{lang}/{product_category_id}',

        banners:                                '/banner/{lang}/',
        banners_update:                         '/banner/{lang}/{banner_id}',
        banners_activate:                       '/banner/{lang}/activate/{banner_id}/{isactive}',

        statistics:                              '/statistics/{lang}/',
        statistics_update:                       '/statistics/{lang}/{statistics_id}',
        statistics_activate:                     '/statistics/{lang}/activate/{statistics_id}/{isactive}',

        doyouknow:                              '/doyouknow/{lang}/',
        doyouknow_update:                       '/doyouknow/{lang}/{doyouknow_id}',
        doyouknow_activate:                     '/doyouknow/{lang}/activate/{doyouknow_id}/{isactive}',

        filter:                                 '/filter/{lang}/',
        filter_list:                            '/filter/{lang}/list',
        filter_update:                          '/filter/{lang}/{filter_id}',
        filter_group_with_filters:              '/filter/{lang}/{filter_id}/with_filters',
        filter_activate:                        '/filter/{lang}/activate/{filter_id}/{isactive}',
        filters_by_group:                       '/filter/{lang}/filters_by_group/{filter_id}',
    },

    getters: {
        // ---------------------------------------------------------------------------------------------
        getMenu: (state) => () => {
            return state.api.menu.replace('{lang}', state.lang);
        },
        getMenuList: (state) => () => {
            return state.api.menu_list.replace('{lang}', state.lang);
        },
        getMenuUpdate: (state) => (menu_id) => {
            return state.api.menu_update.replace('{lang}', state.lang).replace('{menu_id}', menu_id);
        },
        getMenuActivate: (state) => (menu_id, isactive) => {
            return state.api.menu_activate.replace('{lang}', state.lang).replace('{menu_id}', menu_id).replace('{isactive}', isactive);
        },

        // ---------------------------------------------------------------------------------------------
        getCategory: (state) => () => {
            return state.api.category.replace('{lang}', state.lang);
        },
        getCategoryList: (state) => () => {
            return state.api.category_list.replace('{lang}', state.lang);
        },
        getCategoryUpdate: (state) => (category_id) => {
            return state.api.category_update.replace('{lang}', state.lang).replace('{category_id}', category_id);
        },
        getCategoryActivate: (state) => (category_id, isactive) => {
            return state.api.category_activate.replace('{lang}', state.lang).replace('{category_id}', category_id).replace('{isactive}', isactive);
        },

        // ---------------------------------------------------------------------------------------------
        // getProducts: (state) => () => {
        //     return state.api.products.replace('{lang}', state.lang);
        // },
        // getProductsUpdate: (state) => (product_id) => {
        //     return state.api.products_update.replace('{lang}', state.lang).replace('{product_id}', product_id);
        // },

        // ---------------------------------------------------------------------------------------------
        getProducts: (state) => () => {
            return state.api.products.replace('{lang}', state.lang);
        },
        getProductsLazy: (state) => () => {
            return state.api.products_lazy.replace('{lang}', state.lang);
        },
        getProductsUpdate: (state) => (product_id) => {
            return state.api.products_update.replace('{lang}', state.lang).replace('{product_id}', product_id);
        },
        getProductsImageRemove: (state) => (product_id) => {
            return state.api.products_image_remove.replace('{lang}', state.lang).replace('{product_id}', product_id);
        },
        getProductsActivate: (state) => (product_id, isactive) => {
            return state.api.products_activate.replace('{lang}', state.lang).replace('{product_id}', product_id).replace('{isactive}', isactive);
        },
        getProductsWEBActivate: (state) => (product_id, isactive) => {
            return state.api.products_web_activate.replace('{lang}', state.lang).replace('{product_id}', product_id).replace('{isactive}', isactive);
        },

        // getProductsCategory: (state) => () => {
        //     return state.api.products_category.replace('{lang}', state.lang);
        // },
        // getProductsCategoryUpdate: (state) => (product_category_id) => {
        //     return state.api.products_category_update.replace('{lang}', state.lang).replace('{product_category_id}', product_category_id);
        // },

        getBanners: (state) => () => {
            return state.api.banners.replace('{lang}', state.lang);
        },
        getBannersUpdate: (state) => (banner_id) => {
            return state.api.banners_update.replace('{lang}', state.lang).replace('{banner_id}', banner_id);
        },
        getBannersActivate: (state) => (banner_id, isactive) => {
            return state.api.banners_activate.replace('{lang}', state.lang).replace('{banner_id}', banner_id).replace('{isactive}', isactive);
        },

        getStatistics: (state) => () => {
            return state.api.statistics.replace('{lang}', state.lang);
        },
        getStatisticsUpdate: (state) => (statistics_id) => {
            return state.api.statistics_update.replace('{lang}', state.lang).replace('{statistics_id}', statistics_id);
        },
        getStatisticsActivate: (state) => (statistics_id, isactive) => {
            return state.api.statistics_activate.replace('{lang}', state.lang).replace('{statistics_id}', statistics_id).replace('{isactive}', isactive);
        },

        getDoyouknow: (state) => () => {
            return state.api.doyouknow.replace('{lang}', state.lang);
        },
        getDoyouknowUpdate: (state) => (doyouknow_id) => {
            return state.api.doyouknow_update.replace('{lang}', state.lang).replace('{doyouknow_id}', doyouknow_id);
        },
        getDoyouknowActivate: (state) => (doyouknow_id, isactive) => {
            return state.api.doyouknow_activate.replace('{lang}', state.lang).replace('{doyouknow_id}', doyouknow_id).replace('{isactive}', isactive);
        },

        // ---------------------------------------------------------------------------------------------
        getManufacturer: (state) => () => {
            return state.api.manufacturer.replace('{lang}', state.lang);
        },
        getManufacturerList: (state) => () => {
            return state.api.manufacturer_list.replace('{lang}', state.lang);
        },
        getManufacturerUpdate: (state) => (manufacturer_id) => {
            return state.api.manufacturer_update.replace('{lang}', state.lang).replace('{manufacturer_id}', manufacturer_id);
        },
        getManufacturerActivate: (state) => (manufacturer_id, isactive) => {
            return state.api.manufacturer_activate.replace('{lang}', state.lang).replace('{manufacturer_id}', manufacturer_id).replace('{isactive}', isactive);
        },

        // ---------------------------------------------------------------------------------------------
        getFilter: (state) => () => {
            return state.api.filter.replace('{lang}', state.lang);
        },
        getFilterList: (state) => () => {
            return state.api.filter_list.replace('{lang}', state.lang);
        },
        getFilterUpdate: (state) => (filter_id) => {
            return state.api.filter_update.replace('{lang}', state.lang).replace('{filter_id}', filter_id);
        },
        getFilterGroupWithFilters: (state) => (filter_id) => {
            return state.api.filter_group_with_filters.replace('{lang}', state.lang).replace('{filter_id}', filter_id);
        },
        getFilterActivate: (state) => (filter_id, isactive) => {
            return state.api.filter_activate.replace('{lang}', state.lang).replace('{filter_id}', filter_id).replace('{isactive}', isactive);
        },
        getFiltersByGroupID: (state) => (filter_id) => {
            return state.api.filters_by_group.replace('{lang}', state.lang).replace('{filter_id}', filter_id);
        },
    },
    actions: {
        //
    }

};
